export default __webpack_public_path__ + "static/daohaus-e3ccaece797b011d5dc09374a401a999.jpg";